import axios from "axios"
import { EmployeeBansFormInterface, EmployeeBansInterface } from "@type/employees.types"

const ROOT_PATH = "employees/ban"

export default class EmployeesBanService {
	static createEmployeeBan = (ban: EmployeeBansFormInterface) => axios.post<EmployeeBansFormInterface>(ROOT_PATH, ban)

	static updateEmployeeBan = (id: string, ban: EmployeeBansFormInterface) =>
		axios.put<EmployeeBansFormInterface>(`${ROOT_PATH}/${id}`, ban)

	static deleteEmployeeBanById = (id: string) => axios.delete(`${ROOT_PATH}/${id}`)

	static findEmployeeBanByEmployeeID = (id: string) => axios.get<EmployeeBansInterface[]>(`${ROOT_PATH}/${id}`)

	static getEmployeeBanByLocation = (site: string, branch: string, customer: string) =>
		axios.get<EmployeeBansInterface[]>(`${ROOT_PATH}-by-location`, {
			params: { site, branch, customer },
		})
}
